import type { PersonalInfo } from "./borrower";

export enum Sex {
  UNKNOWN = 'unknown',
  FEMALE = 'female',
  MALE = 'male',
  DO_NOT_WISH_TO_PROVIDE = 'doNotWishToProvide'
}

export enum CollectionMethod {
  UNKNOWN = 'unknown',
  FACE_TO_FACE = 'faceToFace',
  TELEPHONE = 'telephone',
  FAX = 'fax',
  EMAIL = 'email'
}

export interface HispanicOrigin {
  mexican?: boolean;
  puertoRican?: boolean;
  cuban?: boolean;
  other?: string;
}

export interface Asian {
  isAsianIndian?: boolean;
  isChinese?: boolean;
  isFilipino?: boolean;
  isJapanese?: boolean;
  isKorean?: boolean;
  isVietnamese?: boolean;
  other?: string;
}

export interface PacificIslander {
  isNativeHawaiian?: boolean;
  isGuamanianOrChamorro?: boolean;
  isSamoan?: boolean;
  other?: string;
}

export interface Ethnicity {
  isHispanicOrLatino?: boolean;
  hispanicOrigin?: HispanicOrigin;
  isNotHispanicOrLatino?: boolean;
  doNotWishToProvide?: boolean;
}

export interface Race {
  isAmericanIndian?: boolean;
  tribe?: string;
  isAsian?: boolean;
  asian?: Asian;
  isBlackOrAfricanAmerican?: boolean;
  isPacificIslander?: boolean;
  pacificIslander?: PacificIslander;
  isWhite?: boolean;
  doNotWishToProvide?: boolean;
}

export interface Demographic {
  id?: string;
  borrowerId?: string;
  loanApplicationId?: string;
  ethnicity?: Ethnicity;
  race?: Race;
  sex?: Sex | null;
  collectionMethod?: CollectionMethod | null;
  isEthnicityVisuallyObserved?: boolean | null;
  isRaceVisuallyObserved?: boolean | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface LoanApplicationDemographicData {
  _id: string;
  borrowerId: string;
  type: 'PRIMARY' | 'CO_BORROWER';
  loanApplicationId: string;
	personalInfo: PersonalInfo;
  demographic: Demographic;
  createdAt: Date;
  updatedAt: Date;
}
